// src/components/ui/Section.tsx
import React from "react";

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  id?: string;
  className?: string;
  div?: boolean;
}

const Section: React.FC<SectionProps> = ({
  children,
  className = "",
  id,
  div = false,
  ...rest
}) => {
  if (div) {
    return (
      <div className={`section ${className}`} id={id} {...rest}>
        {children}
      </div>
    );
  }

  return (
    <section className={`section ${className}`} id={id} {...rest}>
      {children}
    </section>
  );
};

export default Section;
